import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ManagerDashboardService } from '../../services/manager-dashboard.service';
import { Account } from '../../models/account';
import { TeamRequest } from '../../models/teamRequest';
import { LoggingService } from '../../services/logging.service';
import { Router } from '@angular/router';
import { Team } from '../../models/team';

@Component({
  selector: 'app-add-team',
  standalone: false,
  templateUrl: './add-team.component.html',
  styleUrl: './add-team.component.scss'
})
export class AddTeamComponent implements OnInit, OnDestroy {

  teamForm !: FormGroup;
  managerSubscription !: Subscription;
  account !: Account;
  managerId !: number;
  teamSubscription !: Subscription;

  constructor(private fb: FormBuilder, private managerDashboardService : ManagerDashboardService,
              private loggingService : LoggingService, private router : Router) {}

  buildTeamForm() {
    this.teamForm = this.fb.group({
      name: ['', Validators.required],
      description: ['', Validators.required]
    });
  }

  ngOnInit() {
    this.buildTeamForm();
    this.loggingService.logDebug("Getting the managerId from session storage");
    const managerid = sessionStorage.getItem('manager_id');
    if(managerid) {
      this.managerId = parseInt(managerid, 10);
    }
    this.managerSubscription = this.managerDashboardService.getManagerDetails(this.managerId).subscribe(
      (manager) => {
        this.account = manager.account;
    });
  }

  onSubmit(event: Event) {
   event.preventDefault(); 

  const form = event.target as HTMLFormElement;

  if (!form.checkValidity()) {
    form.reportValidity(); 
    return;
  }
  if (this.teamForm.invalid) {
    this.teamForm.markAllAsTouched();
    return;
  }
  const team: TeamRequest = { 
    ...this.teamForm.value,
    managerId: this.managerId,
    accountId: this.account.accountId
  };

    this.teamSubscription = this.managerDashboardService.createTeam(team).subscribe((createdTeam) => {
      this.teamAdded.emit(createdTeam); 
      this.teamForm.reset();
      form.reset(); 
    });
  
}


  ngOnDestroy() {
  
    this.managerSubscription.unsubscribe();
    if(this.teamSubscription){
      this.teamSubscription.unsubscribe();
    }
    
  }

  @Output() teamAdded = new EventEmitter<Team>();

}

